import { Pipe, PipeTransform } from '@angular/core';
import { ToastIcon } from '@shared/types';

/**
 * Get icon class to toast type
 */
@Pipe({
  name: 'iconClass',
  standalone: false,
})
export class ToastIconPipe implements PipeTransform {
  public transform(toastType: string): string {
    return ToastIcon[toastType.toLocaleUpperCase()] || ToastIcon.DEFAULT;
  }
}
